module.exports = __webpack_public_path__ + "static/media/karbarHamzaman.1c2ed411.svg";